import React from "react";

function MapLocationIcon() {
  return (
    <svg
      width="36"
      height="40"
      viewBox="0 0 36 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36.0002" height="40" rx="8" fill="#FA9C03" />
      <path
        d="M18.0001 10C13.5891 10 10.0001 13.589 10.0001 17.995C9.97108 24.44 17.6961 29.784 18.0001 30C18.0001 30 26.0291 24.44 26.0001 18C26.0001 13.589 22.4111 10 18.0001 10ZM18.0001 22C15.7901 22 14.0001 20.21 14.0001 18C14.0001 15.79 15.7901 14 18.0001 14C20.2101 14 22.0001 15.79 22.0001 18C22.0001 20.21 20.2101 22 18.0001 22Z"
        fill="white"
      />
    </svg>
  );
}

export default MapLocationIcon;
